import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { getCompanyLaunches, updateLaunchRankings } from '../../utils/api/admin';

function Launches() {
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedLaunch, setSelectedLaunch] = useState('all');
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';

  useEffect(() => {
    async function loadData(){
      let res = await getCompanyLaunches();
      if (res.success){
        setData(res.data);
        setFilteredData(res.data);
        setLoaded(true);
      }
      else{
        setLoaded(true);
        alert(res.message);
      }
    }

    loadData();
  }, []);

  const getLaunchNames = () => {
    const launches = [...new Set(data.map(item => item.launch_name))];
    return launches;
  };

  const handleLaunchFilter = (e) => {
    const launch = e.target.value;
    setSelectedLaunch(launch);
    if (launch === 'all') {
      setFilteredData(data);
    } else {
      setFilteredData(data.filter(item => item.launch_name === launch));
    }
  };

  const handleDetailsClick = (item) => {
    setSelectedItem(item);
    setShowDetailsModal(true);
  }

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  async function updateRankings(){
    let res = await updateLaunchRankings(selectedLaunch);

    if (res.success){
      alert("done");
      // setData(res.data);
      // setFilteredData(res.data);
      // loadSaveBanner();
    }
    else{
      alert(res.message);
    }


  }

  return (
    <>
      <Helmet>
        <title>LeadrPro - Discover new software</title>
      </Helmet>

      <h1>Company Launches {`(${filteredData.length})`}</h1>

      {loaded===false && (
        <Spinner />
      )}

      {loaded && (
         <div>
          <div className="mb-4">
            <select 
              value={selectedLaunch}
              onChange={(e) => handleLaunchFilter(e)}
              className="border rounded px-3 py-1"
            >
              <option value="all">All Launches</option>
              {getLaunchNames().map((launch, index) => (
                <option key={index} value={launch}>{launch}</option>
              ))}
            </select>

            <button className="ml-4 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
              onClick={() => updateRankings()}
            >
              Update Rankings
            </button>
          </div>

          <table className='admindashboard__table table'>
            <thead>
              <tr>
                <th>ID</th>
                <th>Date Created</th>
                <th>Company Name</th>
                <th>Website</th>
                <th>Status</th>
                <th>Launch Name</th>
                <th>Launch Status</th>
                <th>score</th>
                <th>Position</th>
                <th>Launch Period</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={index}>
                  <td>{item.launch_id}</td>
                  <td>{new Date(item.date_created).toLocaleDateString()}</td>
                  <td>{item.name}</td>
                  <td>
                    <a href={item.website} target="_blank" rel="noopener noreferrer" 
                       className="text-blue-600 hover:text-blue-800">
                      {item.website}
                    </a>
                  </td>
                  <td>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                      ${item.status === 'Active' ? 'bg-green-100 text-green-800' : 
                        item.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : 
                        'bg-gray-100 text-gray-800'}`}>
                      {item.status}
                    </span>
                  </td>
                  <td>{item.launch_name}</td>
                  <td>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                      ${item.launch_status === 'Running' ? 'bg-green-100 text-green-800' : 
                        item.launch_status === 'Active' ? 'bg-yellow-100 text-yellow-800' : 
                        'bg-gray-100 text-gray-800'}`}>
                      {item.launch_status}
                    </span>
                  </td>

                  <td>
                        {item.activity_score}
                  </td>

                  <td>
                    {item.position}
                  </td>

                  <td>
                    {new Date(item.launch_date_start).toLocaleDateString()} - {new Date(item.launch_date_end).toLocaleDateString()}
                  </td>
                  <td>
                    <div className="flex gap-2">
                      <button 
                        onClick={() => handleDetailsClick(item)}
                        className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600">
                        Details
                      </button>
                      <button 
                        onClick={() => setShowModal(true)}
                        className="text-gray-600 hover:text-gray-900">
                        <FaEllipsisV />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
       </div>
      )}

    {showModal && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowModal(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Admin Note</h2>

            <div className='mt-10'>
            
            </div>
          </div>
        </>
      )}

      {showDetailsModal && selectedItem && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowDetailsModal(false)}>
              <FaTimes />
            </div>
            <h2 className='modal__h2'>Launch Details</h2>
            <div className='mt-4 space-y-4'>
              <p><strong>Company:</strong> {selectedItem.name}</p>
              <p><strong>Launch Name:</strong> {selectedItem.launch_name}</p>
              <p><strong>Website:</strong> <a href={selectedItem.website} target="_blank" rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800">{selectedItem.website}</a></p>
              <p><strong>Status:</strong> {selectedItem.status}</p>
              <p><strong>Launch Status:</strong> {selectedItem.launch_status}</p>
              <p><strong>Launch Period:</strong> {new Date(selectedItem.launch_date_start).toLocaleDateString()} - {new Date(selectedItem.launch_date_end).toLocaleDateString()}</p>
            </div>
          </div>
        </>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </>
  );
}

export default Launches;